// Display modes for a filter chip's text label. Single source of truth shared by the chip
// components so the allowed set can't drift between them, and so callers can reference named
// constants (e.g. LABEL_MODE.COLLAPSE) instead of bare strings when wiring things up in JS.
export const LABEL_MODE = {
  // Label always visible; a selection reads "label : value" (single) or "label (N)" / "label (All)".
  FULL: 'full',
  // Label shows only while empty; once something is picked the chip shows just the value
  // (the label moves to the hover tooltip).
  COLLAPSE: 'collapse',
  // Icon-only while empty; once picked shows just the value (label moves to the tooltip).
  VALUE: 'value',
};

export const LABEL_MODES = Object.values(LABEL_MODE);

// Clamp any incoming value to a known mode, defaulting to FULL. A typo therefore can never
// produce a half-broken state — it falls back to the safe default (and Vue's prop `validator`
// still surfaces a dev-time warning so the mistake is visible).
export const normalizeLabelMode = (mode) => (LABEL_MODES.includes(mode) ? mode : LABEL_MODE.FULL);
